import { graphql } from "@/gql";

export const vehicleNameQuery = graphql(`
  query VehicleName($id: ID!) {
    vehicle(id: $id) {
      id
      name
    }
  }
`);
